import styled from 'styled-components';
import Modal from 'react-modal';

import { colorAccent, mediaQueryMobileLargeMin } from 'styles';

import Wrapper from 'components/ContentSection';
import ActionButton from 'components/ActionButton';
import BankLabel from './BankLabel';

export const PageContentSection = styled(Wrapper)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const AddBankButton = styled(ActionButton)`
  display: flex;
  justify-content: center;
  margin: 24px 0 0 0;
  width: 100%;

  svg {
    fill: currentColor;
    margin: -2px -4px 0 0;
    stroke-width: 0;
  }
`;

export const BankLink = styled(BankLabel)`
  color: ${colorAccent};
`;

export const BankAmount = styled.span`
  font-weight: bold;
  font-size: 16px;
`;

export const StyledModal = styled(Modal)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0;

  @media all and ${mediaQueryMobileLargeMin} {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0;
    height: 500px;
    width: 320px;
  }
`;
